module.exports = __webpack_public_path__ + "static/media/music.96eeb348.png";